import { useDispatch, useSelector } from "react-redux";
import { downloadBusinessActivitiesReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useBusinessActivitiesReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) =>
      s.data.reports.exchbusiness.businessActivities.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadBusinessActivitiesReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
